<script>
import {mapGetters} from "vuex";
export default {
  data: () => ({
  }),
  computed: {
    ...mapGetters(['isLoadingInboxes'])
  }
}
</script>
<template>
  <v-row v-if="isLoadingInboxes" class="justify-center mt-6">
    <v-col cols="12" sm="8" md="5" class="mx-auto text-center">
      <v-card color="white" elevation="0">
        <v-card-text>
          <h1 class="pl-0 headline text-center primary--text">
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
            {{ $t('component.inbox.loading') }}
          </h1>
          <br />
          <v-alert
            dense
            outlined
            color="primary"
            icon="mdi-information-outline"
            transition="fade-transition">
            <span>
              {{ $t('component.inbox.loading.text') }}
            </span>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
